"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateAllowedOnTimetable = isDateAllowedOnTimetable;
var main_api_1 = require("../main-api");
var filterTimetable_1 = require("./filterTimetable");
var getCurrentTimetableRules_1 = require("./getCurrentTimetableRules");
var getTimezonedDate_1 = require("./getTimezonedDate");
function isTimetableEmpty(timetable) {
    return !timetable || !Array.isArray(timetable) || timetable.length === 0;
}
function isDateAllowedOnTimetable(date, timetable, timezone) {
    if (date === void 0) { date = new Date(); }
    var timezonedDate = (0, getTimezonedDate_1.getTimezonedDate)(date, timezone);
    var filteredTimetable = (0, filterTimetable_1.filterTimetable)(timezonedDate, timetable, timezone);
    if (!filteredTimetable || isTimetableEmpty(filteredTimetable)) {
        return true;
    }
    var currentTimetableRules = (0, getCurrentTimetableRules_1.getCurrentTimetableRules)(timezonedDate, filteredTimetable);
    // RESTRICTION rules will take priority over all ALLOWANCE rules
    return Boolean(currentTimetableRules.length &&
        currentTimetableRules.every(function (r) { return r.type === main_api_1.TimetableRuleType.ALLOWANCE; }));
}
//# sourceMappingURL=isDateAllowedOnTimetable.js.map